import { SET_ACTIVE_MENU } from '../../constants';

const initialState = {
  menu: [
    {
      icon: (
        <svg
          width='32'
          height='26'
          viewBox='0 0 32 26'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M22.3333 25V22.3333C22.3333 20.9188 21.7714 19.5623 20.7712 18.5621C19.771 17.5619 18.4145 17 17 17H6.33333C4.91885 17 3.56229 17.5619 2.5621 18.5621C1.5619 19.5623 1 20.9188 1 22.3333V25'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.6663 11.6667C14.6119 11.6667 16.9997 9.27885 16.9997 6.33333C16.9997 3.38781 14.6119 1 11.6663 1C8.72082 1 6.33301 3.38781 6.33301 6.33333C6.33301 9.27885 8.72082 11.6667 11.6663 11.6667Z'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M30.333 25.0005V22.3338C30.3321 21.1521 29.9388 20.0042 29.2148 19.0702C28.4908 18.1363 27.4772 17.4693 26.333 17.1738'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21 1.17383C22.1472 1.46756 23.164 2.13476 23.8902 3.07024C24.6163 4.00572 25.0105 5.15627 25.0105 6.34049C25.0105 7.52472 24.6163 8.67527 23.8902 9.61075C23.164 10.5462 22.1472 11.2134 21 11.5072'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      ),
      type: 'https://corp.cloveri.com/',
      name: 'Сотрудники',
    },
    {
      icon: (
        <svg
          width='32'
          height='26'
          viewBox='-5 0 32 26'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M5.66671 3.07143H6.16671V2.57143L6.16671 1.7148C6.16671 1.71467 6.16671 1.71454 6.16671 1.71441C6.16714 1.39844 6.29734 1.09169 6.53499 0.862526C6.77331 0.632719 7.10017 0.50039 7.44474 0.5H19.8887C20.2332 0.50039 20.5601 0.632719 20.7984 0.862526C21.0362 1.09179 21.1664 1.3987 21.1667 1.7148V5.14234C21.1664 5.45845 21.0362 5.76535 20.7984 5.99462C20.56 6.22447 20.2331 6.35681 19.8884 6.35714H7.44497C7.10031 6.35681 6.77336 6.22447 6.53499 5.99462C6.29734 5.76545 6.16714 5.4587 6.16671 5.14273C6.16671 5.1426 6.16671 5.14247 6.16671 5.14234L6.16671 4.28571V3.78571H5.66671H2.11115H1.61115V4.28571V11.1429V11.6429H2.11115H5.66671H6.16671V11.1429L6.16671 10.2862C6.16671 10.2861 6.16671 10.286 6.16671 10.2858C6.16714 9.96987 6.29734 9.66312 6.53499 9.43396C6.77336 9.2041 7.10031 9.07176 7.44497 9.07143H19.8884C20.2331 9.07176 20.56 9.2041 20.7984 9.43396C21.0362 9.66322 21.1664 9.97013 21.1667 10.2862V13.7138C21.1664 14.0299 21.0362 14.3368 20.7984 14.566C20.56 14.7959 20.2331 14.9282 19.8884 14.9286H7.44497C7.10031 14.9282 6.77336 14.7959 6.53499 14.566C6.29734 14.3369 6.16714 14.0301 6.16671 13.7142C6.16671 13.714 6.16671 13.7139 6.16671 13.7138L6.16671 12.8571V12.3571H5.66671H2.11115H1.61115V12.8571V19.7143V20.2143H2.11115H5.66671H6.16671V19.7143L6.16671 18.8577C6.16671 18.8575 6.16671 18.8574 6.16671 18.8573C6.16714 18.5413 6.29734 18.2346 6.53499 18.0054C6.77336 17.7755 7.10031 17.6432 7.44497 17.6429H19.8884C20.2331 17.6432 20.56 17.7755 20.7984 18.0054C21.0362 18.2346 21.1664 18.5416 21.1667 18.8577V22.2852C21.1664 22.6013 21.0362 22.9082 20.7984 23.1375C20.56 23.3673 20.2331 23.4997 19.8884 23.5H7.44497C7.10031 23.4997 6.77336 23.3673 6.53499 23.1375C6.29734 22.9083 6.16714 22.6016 6.16671 22.2856C6.16671 22.2855 6.16671 22.2853 6.16671 22.2852L6.16671 21.4286V20.9286H5.66671H2.11163C1.76698 20.9282 1.44003 20.7959 1.20166 20.566C0.963964 20.3368 0.833766 20.03 0.833374 19.714V0.5H1.61115V2.57143V3.07143H2.11115H5.66671ZM7.44448 1.21429H6.94448V1.71429V5.14286V5.64286H7.44448H19.8898H20.3899L20.3898 5.14273L20.3889 1.71416L20.3888 1.21429H19.8889H7.44448ZM7.44448 18.3571H6.94448V18.8571V22.2857V22.7857H7.44448H19.8898H20.3899L20.3898 22.2856L20.3889 18.857L20.3888 18.3571H19.8889H7.44448ZM7.44448 9.78571H6.94448V10.2857V13.7143V14.2143H7.44448H19.8898H20.3899L20.3898 13.7142L20.3889 10.2856L20.3888 9.78571H19.8889H7.44448Z'
            stroke='#737373'
          />
        </svg>
      ),
      type: 'structure',
      name: 'Орг. структура',
    },
    {
      icon: (
        <svg
          width='32'
          height='26'
          viewBox='0 0 32 26'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M21.3335 25V22.3333C21.3335 20.9188 20.7716 19.5623 19.7714 18.5621C18.7712 17.5619 17.4147 17 16.0002 17H6.66683C5.25234 17 3.89579 17.5619 2.89559 18.5621C1.8954 19.5623 1.3335 20.9188 1.3335 22.3333V25'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.3333 11.6667C14.2789 11.6667 16.6667 9.27885 16.6667 6.33333C16.6667 3.38781 14.2789 1 11.3333 1C8.38781 1 6 3.38781 6 6.33333C6 9.27885 8.38781 11.6667 11.3333 11.6667Z'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.6667 7.66699V15.667'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M30.6665 11.667H22.6665'
            stroke='#737373'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      ),
      type: 'https://corp.cloveri.com/vacancies',
      name: 'Вакансии',
    },
  ],
  activeMenu: null,
};

const menu = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_MENU:
      return {
        ...state,
        activeMenu: action.payload,
      };

    default:
      return state;
  }
};

export default menu;
